export default __webpack_public_path__ + "assets/images/04092722fff5af7821b4f37e6918ae0c.svg";